/**
 * @file LookPhoneGroup.tsx
 * @description Группа «Телефон и видимость» секции (phase19.16 Р2;
 * uiux-design-r2 §2, §12 п.6): порядок колонок на телефоне и «Показывать»
 * Телефон / Планшет / ПК. SB120 этап 1 (uiux-sb120-stage1 §2.6): порядок
 * для 2–4 колонок списком с перетаскиванием и ▲▼ (`PhoneOrderField`); у
 * одной колонки строки нет.
 * Р2а: блок шаблона товара с обязательными элементами виден на всех
 * устройствах — галочки неактивны с причиной (иначе сервер ответит 422).
 */

import type { SectionPayload } from "@chaiberi/shared";

import { DeviceVisibilityField } from "../fields/DeviceVisibilityField";
import { useSectionForm } from "../section-form-context";
import { PhoneOrderField } from "./PhoneOrderField";
import { REQUIRED_BLOCK_DEVICES_TEXT } from "../../../../lib/site-builder/product-element-meta";
import { requiredIn } from "../../../../lib/site-builder/template-rules";

export function LookPhoneGroup({ payload, onChange }: { payload: SectionPayload; onChange: (payload: SectionPayload) => void }) {
  const { context } = useSectionForm();
  const locked = context === "productTemplate" && requiredIn(payload).length > 0;
  return (
    <div className="flex flex-col gap-3">
      <PhoneOrderField
        columns={payload.columns}
        onChange={(phoneOrder) => {
          const columns = { ...payload.columns, phoneOrder };
          if (phoneOrder === undefined) delete columns.phoneOrder;
          onChange({ ...payload, columns });
        }}
      />
      <DeviceVisibilityField
        value={payload.look.visibility}
        onChange={(visibility) => onChange({ ...payload, look: { ...payload.look, visibility } })}
        lockedReason={locked ? REQUIRED_BLOCK_DEVICES_TEXT : null}
      />
    </div>
  );
}
